import { ClearDriveAction, CLEAR_DRIVE } from './types'

export const clearDrive = (): ClearDriveAction => ({
		type: CLEAR_DRIVE
	})
